module.exports = __webpack_public_path__ + "static/media/expense.20000a66.svg";